import { parseString } from "../Generic/Strings";

/**
 * Gets and parses search query from window url
 */
export function getURLQuery(
    parse = false,
    from?: string
): Record<
    string,
    ReturnType<typeof parseString> | Array<ReturnType<typeof parseString>>
> {
    const results: Record<string, ReturnType<typeof parseString> | Array<ReturnType<typeof parseString>>> = {};
    let query = "";

    if(typeof from !== "undefined") {
        query = from;
    } else {
        if(typeof window === "undefined") {
            return results;
        }

        query = window.location.search;
    }

    // Return if query empty
    if(!query) {
        return results;
    }

    // Remove '?' from start of string and split on '&'
    const querySplit = query.substr(1).split("&");

    for(let i = 0; i < querySplit.length; i++) {
        // Split key/value pair
        const pair = querySplit[i].split("=");

        // Parse key/value pair
        let key = decodeURIComponent(pair[0]);
        let value: ReturnType<typeof parseString> = decodeURIComponent(pair[1]);

        // Check if the key has an array accessor
        if(key.slice(-2) === "[]") {
            key = key.slice(0, -2);
        }

        // Parse string value
        if(parse) {
            value = parseString(value);
        }

        if(typeof results[key] === "undefined") {
            // Create value
            results[key] = value;
        } else if(Array.isArray(results[key])) {
            // Push into array
            (results[key] as Array<ReturnType<typeof parseString>>).push(value);
        } else {
            // Two of the same key has been set, make array
            results[key] = [ results[key], value ] as Array<ReturnType<typeof parseString>>;
        }
    }

    return results;
}

let initialSearch;

if(typeof document !== "undefined") {
    initialSearch = new URLSearchParams(document.location.search);
} else {
    initialSearch = new URLSearchParams();
}

export const EMBEDDED_PARAM_NAME = "sf_embedded";
export const hasIntegrationSetting = initialSearch.has(EMBEDDED_PARAM_NAME);
export const DISABLE_EMBEDDED = initialSearch.get(EMBEDDED_PARAM_NAME) === "false";
